import { Link } from "react-router-dom";

const columns = [
  {
    title: "影视分类",
    links: [
      { label: "电影频道", to: "/category/movie" },
      { label: "电视剧频道", to: "/category/drama" },
      { label: "影视搜索", to: "/search" },
    ],
  },
  {
    title: "关于缘之空",
    links: [
      { label: "网站简介", to: "/about" },
      { label: "联系方式", to: "/about" },
      { label: "版权声明", to: "/about" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="px-4 md:px-8 py-12 md:py-16">
        <div className="max-w-[1280px] mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-md bg-accent-500 flex items-center justify-center">
                <i className="ri-movie-2-line text-lg text-background-50"></i>
              </span>
              <span className="font-heading font-black text-xl text-background-50">缘之空</span>
            </div>
            <p className="text-sm leading-relaxed text-background-300 max-w-md">
              缘之空是一个专注影视内容展示的平台，聚合电影与电视剧的海报、剧情简介、演员及制作信息，
              帮助观众在观影之前快速了解作品，做出更合适的选择。
            </p>
            <p className="mt-4 text-xs text-background-400">
              本站仅提供影视资料与剧情介绍，不含在线播放、下载等功能。
            </p>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="text-background-50 font-heading font-bold mb-4 text-sm tracking-wide">
                {col.title}
              </h4>
              <ul className="space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-300 hover:text-accent-400 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="border-t border-background-800">
        <div className="max-w-[1280px] mx-auto px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-400">
          <p>© 2026 缘之空 YUANZHIKONG. 保留所有权利。</p>
          <p>影视资料仅供浏览参考 · 内容持续更新中</p>
        </div>
      </div>
    </footer>
  );
}